<div class="closeButton" >
    <button mat-icon-button [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div>
    <div >
        <mat-card align="center"  >
            <table width="100%" #screen align="center" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                    <tr>
                        <td align="center" valign="middle" >
                                <!-- <table width="300" height="100"  border="0" cellspacing="0" cellpadding="0">
                                    <tbody>
                                        <tr>
                                            <td align="center" valign="top" class="topCard" bgcolor="#650bea">
                                                <div class="parent"  >
                                                    <img class="image1" src="assets/images/svg/netzwerke.svg" />
                                                    <img class="image2" src="{{image}}" height="100px"/>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> -->
                                <table width="300" height="20"  border="0" cellspacing="0" cellpadding="0">
                                    <tbody>
                                        <tr>
                                            <td align="center" valign="top" class="topCard" bgcolor="#650bea">
                                                    <div class="parent"  >
                                                        <img class="image1" src="assets/images/svg/netzwerke_bigger2.png" />
                                                        <br>
                                                        <span class="imageName">{{screenname}}</span>
                                                        <br>
                                                    </div>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table width="340" border="0" cellspacing="0" cellpadding="0">
                                    <tbody>
                                        <tr height="0">
                                            <td width="20" height="20" valign="bottom"><img src="assets/images/linksKlappe.png" class="kachelbottom"  alt=""/></td>
                                            <td width="300" align="center" height="0" bgcolor="#650bea">
                                            </td>
                                            <td width="20" height="20" valign="bottom"><img src="assets/images/rechtsKlappe.png" class="kachelbottom" alt=""/></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table width="340" height="100" border="0" bordercolor="red" cellspacing="0" cellpadding="0">
                                    <tbody>
                                        <tr>
                                            <td bgcolor="#f4f4f4" >
                                                <table width="100%" class="logoOver" height="100"  cellspacing="0" cellpadding="0">
                                                    <tbody>
                                                        <tr>
                                                            <td width="26%" align="center" >
                                                                <img   src="assets/images/svg/newlogo_white.png" height="80px" alt="">
                                                            </td>
                                                            <td width="74%" align="center" valign="top">
                                                                <table  height="100" width="100%" border="0" cellspacing="0" cellpadding="0">
                                                                    <tbody>
                                                                        <tr >
                                                                            <td align="center" valign="middle" >
                                                                                <img src="assets/images/svg/followMe.png" width="70%" alt="">
                                                                            </td>
                                                                        </tr>

                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            <table width="300" height="160" border="0" cellspacing="0" cellpadding="0">
                                <tbody>
                                    <tr>
                                        <td align="center" valign="middle" class="bottomCard" bgcolor="#650bea" color="white">
                                            <div class="parentBigger">
                                                <img class="image1Bigger" src="assets/images/svg/netzwerke_bigger.png" />
                                                <ngx-qrcode
                                                    class="image2Bigger"
                                                    [elementType]="elementType"
                                                    [value]="value"
                                                    cssClass="aclass"
                                                    errorCorrectionLevel="L">
                                                </ngx-qrcode>
                                            </div>


                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p></td>
                    </tr>
                </tbody>
            </table>
            <button mat-raised-button [mat-dialog-close]="true" (click)="downloadImage()" color="accent">Download</button>

        </mat-card>
    </div>

</div>

<div id="download">
  <img #canvas>
  <a #downloadLink></a>
</div>
